import React from "react";
import ReactDOM from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import { EventType } from "@azure/msal-browser";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import App from "./App";
import { msalInstance } from "./msalInstance";
import "./i18n";

// Suppress benign ResizeObserver errors
window.addEventListener("error", (e) => {
  if (
    e.message === "ResizeObserver loop limit exceeded" ||
    e.message ===
      "ResizeObserver loop completed with undelivered notifications."
  ) {
    e.stopImmediatePropagation();
  }
});

// La instancia MSAL vive en ./msalInstance (también la usa utils/apiFetch.js)

// Fijar cuenta activa cuando el login por redirect sea exitoso
msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload?.account) {
    msalInstance.setActiveAccount(event.payload.account);
  }
});

// Renderizar la app envuelta con MsalProvider
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </React.StrictMode>,
);
